const BASE = "/auth";

const REGISTER = `${BASE}/register`;
const LOGIN = `${BASE}/login`;
const REFRESH_ACCESS_TOKEN = `${BASE}/refresh-access-token`;
const VERIFY_ACCESS_TOKEN = `${BASE}/verify-access-token`;
const VERIFY_REFRESH_TOKEN = `${BASE}/verify-refresh-token`;
const ME = `${BASE}/me`;
const UPDATE_PROFILE = `${BASE}/update-profile`;
const RESET_PASSWORD = `${BASE}/reset-password`;
const CHANGE_PASSWORD = `${BASE}/change-password`;
const FORGOT_PASSWORD = `${BASE}/forgot-password`;

export const AUTH_ROUTE = {
  REGISTER,
  LOGIN,
  REFRESH_ACCESS_TOKEN,
  VERIFY_ACCESS_TOKEN,
  VERIFY_REFRESH_TOKEN,
  ME,
  UPDATE_PROFILE,
  RESET_PASSWORD,
  CHANGE_PASSWORD,
  FORGOT_PASSWORD,
};
